<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type {
  MenuItem,
  MenuItemTranslation,
} from '@/presentation/components/mainmenu/MenuItem.ts';

const { t } = useI18n();
const props = defineProps<{ collapsed: boolean }>();

const visible = ref(false);
const top = ref(0);
const left = ref(0);
const translation = ref<MenuItemTranslation | null>(null);

function onEnter(e: MouseEvent, item: MenuItem) {
  if (!props.collapsed) {
    return;
  }

  const el = e.currentTarget as HTMLElement;
  const rect = el.getBoundingClientRect();
  top.value = rect.top + rect.height / 2 + window.scrollY;
  left.value = rect.right + 12 + window.scrollX;
  translation.value = item.translation;
  visible.value = true;
}

function onLeave() {
  visible.value = false;
}

defineExpose({ onEnter, onLeave });
</script>

<template>
  <teleport to="body">
    <div
      v-if="visible && translation"
      class="fixed z-50 bg-gray-900 text-white text-sm rounded-md px-2 py-1 shadow-lg pointer-events-none"
      :style="{ top: top + 'px', left: left + 'px', transform: 'translateY(-50%)' }"
    >
      {{ t(translation.key, translation.params) }}
    </div>
  </teleport>
</template>
